import { RootState } from '../../rootReducer';

export const cloudSelectors = {
  getClouds: (state: RootState) => state.CloudsState.clouds,
  getInstitutionClouds: (state: RootState) =>
    state.CloudsState.institutionClouds,
  getPermissions: (state: RootState) => state.CloudsState.permissions,
  getKnownClouds: (state: RootState) =>
    Object.values(state?.CloudsState?.clouds).filter(
      (cloud) =>
        state?.ReaderState?.readerData?.bookId &&
        cloud.books.indexOf(state?.ReaderState?.readerData?.bookId) !== -1
    ),
  getCloudsForUser: (state: RootState) => state.CloudsState.listCloudForUser,
  getCloudsSearchResult: (state: RootState) =>
    state.CloudsState.searchCloudsResult,
  getCloudsSearchResultWithIds: (state: RootState) => {
    // Please move to external function for sharing
    const current = {
      result: {
        ...state.CloudsState.searchCloudsResult.result,
        items: state.CloudsState.searchCloudsResult.result.items.map((item) => {
          const newItem = {
            ...item,
            id1: 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
              /[xy]/g,
              function (c) {
                var r = (Math.random() * 16) | 0,
                  v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
              }
            ),
          };

          return newItem;
        }),
      },
    };

    return current;
  },
};
